import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function initBasics() {
        
    const menu = jQuery('header');
    
    jQuery('.toggle-menu').click(function(){
        jQuery('body').toggleClass('show-mobile-menu');
    });
    jQuery('.menu-overlay').click(function(){
        jQuery('body').removeClass('show-mobile-menu');
    });

    // Sluit mobiel menu bij klik op link
    jQuery('#mobile-menu a').on('click', function(){
        jQuery('body').removeClass('show-mobile-menu');
    });

    /* Mobile menu */
    jQuery('header #mobile-menu li.menu-item-has-children').on('click', function(event){
        if (jQuery(event.target).closest('a').length) {

        } else {
            jQuery(this).toggleClass('open');
        }
    });

    // Function On Scroll
    jQuery(window).scroll(function() {
        checkMenu(200);
    });
    checkMenu();

    // Make Menu Sticky
    function checkMenu(){
        
        // Add BG when first section has class 'menu-color'
        if (jQuery('section').first().hasClass('menu-color')){
            jQuery(menu).addClass('color');
        } else {
            // Add Color when Scrolled trough first section
            const top = (window.scrollY < (jQuery('section').first().height() - jQuery('#masthead').height()) ? true : false );
            if(!top && window.scrollY !== 0) {
                jQuery(menu).addClass('color');
            } else {
                jQuery(menu).removeClass('color');
            }
        }
    }

    // Open Forms
    jQuery('.open-form').click(function(e){
        e.preventDefault();
        const form = jQuery(this).data('form');
        jQuery('body').attr('data-form', form);
        jQuery('sidebar#' + form).addClass('active');
    });

    // Close Forms
    jQuery('.close-form, sidebar .overlay').click(function(){
        jQuery('body').data('form', '');
        jQuery('sidebar').removeClass('active');
    });
    jQuery(document).on('keyup', function(e) {
        if (e.key === 'Escape') {
            // Escape all Modals and Popups
            jQuery('body').data('form', '');
            jQuery('sidebar').removeClass('active');
            jQuery('body').removeClass('show-mobile-menu');
            jQuery('.unit-details').removeClass('active-unit');
        }
    });

    // Autoplay video
    const video = document.getElementById('hero-video');
    if (video && !isMobileDevice()) {
        video.play();
    }

    function isMobileDevice() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }
    

    if(jQuery('.thumb-swiper').length && jQuery('.gallery-swiper').length){
        const thumbSwiper = new Swiper('.thumb-swiper', {
            modules: [Navigation, Pagination],
            spaceBetween: 4,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 12,
                },
            },
        });

        new Swiper('.gallery-swiper', {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            slidesPerView: 1,
            effect: 'fade',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: thumbSwiper,
            },
        });
    }

    function initCSSMarquee() {
        const pixelsPerSecond = 60;
        const marquees = document.querySelectorAll('[data-css-marquee]');
        
        marquees.forEach(marquee => {
            marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
                const duplicate = list.cloneNode(true);
            
                if (marquee.classList.contains('reverse')) {
                    marquee.insertBefore(duplicate, marquee.firstChild); // Add to the front
                } else {
                    marquee.appendChild(duplicate); // Add to the end
                }
            });
        });
    
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                entry.target.querySelectorAll('[data-css-marquee-list]').forEach(list => 
                    list.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused',
                );
            });
        }, { threshold: 0 });
        
        marquees.forEach(marquee => {
            marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
                list.style.animationDuration = (list.offsetWidth / pixelsPerSecond) + 's';
                list.style.animationPlayState = 'paused';
            });
            observer.observe(marquee);
        });
    }
    
    initCSSMarquee();

}